// Vike calls this once the first client render (hydration) is done; the e2e
// tests wait for the html marker before clicking (see tests/e2e beforeEach).
export function onHydrationEnd() {
  document.documentElement.dataset.hydrated = "1"
}
